// 命名：模块名+功能
export const ACCESS_LOGIN = 'ACCESS_LOGIN' // 授权登录
export const ACCESS_LOGOUT = 'ACCESS_LOGOUT' // 登出



// WEBPACK FOOTER //
// ./src/store/mutations-type.js